import { EntityLookupModel } from "./entity-lookup.model";
import { SearchGlobalModel } from "./search-global.model";

export namespace FlattenEventsWorkerModel {

  export type WorkerMessageType = 'RUN_EVENTS_FLATTEN' | 'RUN_EVENTS_FLATTEN_SUCCESS' | 'RUN_EVENTS_FLATTEN_FAIL';
  type RunEventsFlattenType = Extract<WorkerMessageType, 'RUN_EVENTS_FLATTEN'>;
  type RunEventsFlattenSuccessType = Extract<WorkerMessageType, 'RUN_EVENTS_FLATTEN_SUCCESS'>;
  type RunEventsFlattenFailType = Extract<WorkerMessageType, 'RUN_EVENTS_FLATTEN_FAIL'>;

  export interface RunEventsFlattenMessage {
    type: RunEventsFlattenType;
    requestId: string;
    events?: any[] //EventV2Document[];
    lookups: EntityLookupModel.EntityLookupMap
  }

  export interface RunEventsFlattenSuccessMessage {
    type: RunEventsFlattenSuccessType;
    requestId: string;
    searchableEvents: SearchGlobalModel.SearchEventDocument[],
  }

  export interface RunEventsFlattenFailMessage {
    type: RunEventsFlattenFailType;
    requestId: string;
    error: any;
  }

  export function isRunEventsFlattenSuccessMessage(
    msg: FlattenWorkerMessage
  ): msg is RunEventsFlattenSuccessMessage {
    return msg.type === 'RUN_EVENTS_FLATTEN_SUCCESS';
  }

  export function isRunEventsFlattenFailMessage(
    msg: FlattenWorkerMessage
  ): msg is RunEventsFlattenFailMessage {
    return msg.type === 'RUN_EVENTS_FLATTEN_FAIL';
  }


  export type FlattenWorkerMessage =
    | RunEventsFlattenMessage
    | RunEventsFlattenSuccessMessage
    | RunEventsFlattenFailMessage;


}


